module.exports = __webpack_public_path__ + "static/media/What-we-offer.a6b7578c.jpg";